<template>
  <div class="container">
    <table class="table is-striped is-narrow-tablet is-narrow-mobile is-hoverable">
      <thead>
        <tr>
          <th></th>
          <th>Current/Updated</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td><strong>Username</strong></td>
          <td>{{ user.username }}</td>
        </tr>
        <tr>
          <td><strong>First Name</strong></td>
          <td><input class="input" type="text" v-model="firstName"></td>
        </tr>
        <tr>
          <td><strong>Last Name</strong></td>
          <td><input class="input" type="text" v-model="lastName"></td>
        </tr>
        <tr>
          <td><strong>Email</strong></td>
          <td>{{ user.email }}</td>
        </tr>
        <tr>
          <td><strong>Birthday</strong></td>
          <td>{{ user.dob }}</td>
        </tr>
        <tr>
          <td><strong>Gender</strong></td>
          <td>{{ user.gender }}</td>
        </tr>
        <tr>
          <td><strong>Race</strong></td>
          <td>{{ user.race }}</td>
        </tr>
        <tr>
          <td><strong>Weight</strong></td>
          <td><input class="input" type="number" v-model="weight"></td>
        </tr>
        <tr>
          <td><strong>Height Feet</strong></td>
          <td>{{ user.heightFT }}</td>
        </tr>
        <tr>
          <td><strong>Height Inches</strong></td>
          <td>{{ user.heightIN }}</td>
        </tr>
        <tr>
          <td><strong>Zipcode</strong></td>
          <td><input class="input" type="number" v-model="zipcode"></td>
        </tr>
        <tr><td></td><td><button class="button is-fullwidth" @click="updateUserData()">Update</button></td></tr>
      </tbody>
    </table>
  </div>
</template>

<script>
  import * as firebase from 'firebase'
  export default {
    name: "account",
    data () {
      return {
        userName: '',
        firstName: '',
        lastName: '',
        email: '',
        dob: '',
        gender: '',
        race: '',
        weight: '',
        feet: '',
        inches: '',
        zipcode: ''
      }
    },
    computed: {
      user () {
        return this.$store.getters.user
      }
    },
    mounted() {
      this.firstName = this.user.firstName
      this.lastName = this.user.lastName
      this.weight = this.user.weight
      this.zipcode = this.user.zipcode
    },
    methods: {
      updateUserData() {
        let updatedUser = {
          firstName: this.firstName,
          lastName: this.lastName,
          weight: this.weight,
          zipcode: this.zipcode
        }
        this.$store.dispatch('updateUserData', updatedUser)
      }
    }
  }
</script>

<style scoped>
  thead th {
    color: white;
  }
  .container {
    width: 40%;
  }
</style>



// WEBPACK FOOTER //
// src/components/Account.vue